import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { MenuWrapper } from 'common/mdc/menu';
import Icon from 'common/mdc/icon';
import Button from 'common/mdc/button';
import JobMenu from './menu';
import jobShape from './shape';

const messages = defineMessages({
  actions: {
    id: 'job.actions',
    defaultMessage: 'Actions',
  },
});

const JobActions = ({ job }) => (
  <MenuWrapper
    left={false}
    overlay={false}
    wrappedElement={
      <Button>
        <FormattedMessage {...messages.actions} />
        <Icon className="mdc-button__icon right">arrow_drop_down</Icon>
      </Button>}
  >
    <JobMenu job={job} />
  </MenuWrapper>
);

JobActions.propTypes = {
  job: jobShape.isRequired,
};

export default JobActions;
